<template>
  <div>
    <ul>
      <li>
        <strong>MAE </strong>
        (Mean Absolute Error): Es una medida de la diferencia entre dos variables continuas.
        Considerando dos series de datos (unos calculados y otros observados) relativos a un mismo
        fenómeno, sirve para cuantificar la precisión de una técnica de predicción comparando los
        valores predichos frente a los observados, el tiempo real frente al tiempo previsto
        <div class="equation">
          <img src="/img/mae.png" alt="mae" />
        </div>
      </li>
      <li>
        <strong>MAE porcentual </strong>
        (Mean Absolute Error porcentual): Determina la precisión de la técnica de predicción frente
        a los datos reales mediante el cálculo de la diferencia absoluta promedio entre los dos
        valores a lo largo del tiempo y lo normaliza respecto al valor original. Viene definida de
        acuerdo a la siguiente fórmula:
        <div class="equation">
          <img src="/img/mae_2.png" alt="mae" />
        </div>
        Donde y representa la salida del modelo entrenado, x los valores verdaderos y N el número de
        imágenes evaluadas.
      </li>
    </ul>
  </div>
</template>

<style scoped>
ul > * {
  list-style-type: circle;
  list-style-position: inside;
  word-break: keep-all;
}

li {
  line-height: 1.5;
  margin-bottom: 5px;
}

.equation {
  display: flex;
  justify-content: center;
}
</style>
